import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { PlusCircle } from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import AddRole from "../../core/modals/usermanagement/addrole";
// import EditRole from "../../core/modals/usermanagement/editrole";
// import { all_routes } from "../../Router/all_routes";
import { useToast } from '../../Toaster/ToastContext';
import Loader from '../loader/loader';
import { AllPermissions, deletePermission } from '../../services/authService';

const RolesPermissions = () => {

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentRole, setCurrentRole] = useState(null);
  const { showToast } = useToast();
  const hasFetched = useRef(false);
  
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const fetchRoles = async () => {
    if (hasFetched.current) return;
    setLoading(true);
    try {
      const response = await AllPermissions();
      const data = await response.json();
      const mappedRoles = data.data.map((role) => ({
        id: role.id,
        roles: role.roles,
        permissions: role.permissions,
        created_at: role.created_at
      }));
      setPermissions(mappedRoles);
    } 
    catch (error) {
      showToast(error.message || 'Failed to fetch Permissions', 'error', 'Permissions');
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleAddPermissions = () => {
    setCurrentRole(null);
  };

  const handleEditPermissions = (permission) => {
    setCurrentRole(permission);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setPermissions(
      permissions.filter((permission) =>
        permission.roles.toLowerCase().includes(term) ||
        permission.created_at.toLowerCase().includes(term)
      )
    );
  };

  const columns = [
    {
      title: "Role Name",
      dataIndex: "roles",
      sorter: (a, b) => a.roles.length - b.roles.length,
      render: (text) => <span>{text}</span>,
    },

    {
      title: "Created On",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.length - b.created_at.length,
      render: (text) => {
        const date = new Date(text);
        return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).split('/').join('-');
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td className="action-table-data p-0">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={() => handleEditPermissions(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" to="#">
              <i
                data-feather="trash-2"
                className="feather-trash-2"
                onClick={() => showConfirmationAlert(record)}
              ></i>
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = async (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await deletePermission(record.id);
          showToast('Permission deleted successfully', 'success', 'Permissions');
          hasFetched.current = false;
          await fetchRoles();
        } catch (error) {
          showToast(error.message || 'Failed to delete Permission', 'error', 'Permissions');
        } finally {
          setLoading(false);
        }
      } 
      else {
        MySwal.close();
      }
    });
  };

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Roles &amp; Permission</h4>
                <h6>Manage your roles</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <a to="#" className="btn btn-added"
                data-bs-toggle="modal" data-bs-target="#add-units"
                onClick={handleAddPermissions}
              >
                <PlusCircle className="me-2" />
                Add New Role
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input type="text" placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table columns={columns}
                  dataSource={permissions}
                  rowKey={(record) => record.id}
                  rowSelection={null}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddRole
        roles={currentRole}
        onSave={() => {
          hasFetched.current = false;
          fetchRoles();
        }}
      />
    </div>
  );
};

export default RolesPermissions;
